import { validationInterface } from "../interface/CommonInterface"

export const initValidation : validationInterface = {
    isValid : false,
    isInput : false,
    isSame : false,
    isBoth : false
}